export default __webpack_public_path__ + "static/media/carbon_add-filled-blue.da7d08df.svg";